export default "__VITE_ASSET__CATOu1dm__"